import apiUrl from '../util/apiURL';
import defaultRegion from '../util/defaultRegion';

const Version = '2016-03-04';
const Service = 'kcm';
const apiPath = '/i/security/api';
const apiPathReal = '/i/security/api';
const quotaService = 'quota';

export default {
    QueryPriceSystem: apiUrl('/i/security/api', {
        Action: 'QueryPriceSystem',
        Service: 'kcm',
        Version
    }),
    // 获取cert的列表
    GetCertList: apiUrl(apiPath, {
        Action: 'GetCertList',
    }),
    ListCertificate: apiUrl(apiPath, {
        Action: 'ListCertificates',
        Service, Version
    }),
    GetDownloadLink: apiUrl(apiPath, {
        Action: 'GetDownloadLink',
        Service, Version
    }),
    GetToken: apiUrl(apiPath, {
        Action: 'GetToken',
        Service, Version
    }),
    UpdateCertificate: {
        url: apiUrl(apiPath, {
            Action: 'UpdateCertificate',
            Service, Version
        }),
        method: 'post'
    },
    // --- 省市列表 ---
    GetArea: {
        url: apiUrl('/i/security/api', {
            Action: 'GetArea',
            Service: 'khs',
            Version: '2016-09-28'
        }),
        method: 'post'
    },
    //-------------
    CreateCertificate: {
        url: apiUrl(apiPath, {
            Action: 'CreateCertificateByConsole',
            Service, Version
        }),
        method: 'post'
    },
    //--- 获取证书详情 ---
    GetCertificateDetail: apiUrl(apiPath, {
        Action: 'GetCertificateDetail',
        Service, Version
    }),
    //--- 取消交易 ---
    CancelTransaction: {
        url: apiUrl(apiPath, {
            Action: 'CancelTransaction',
            Service, Version
        }),
        method: 'post'
    },
    //--- 购买证书 ---
    BatchCreateProduct: {
        url: apiUrl(apiPathReal, {
            Action: 'BatchCreateProduct',
            Service: 'kcm',
            Version
        }),
        method: 'post'
    },
    //--- 计算价格 ---
    BatchCalculateProduct: {
        url: apiUrl(apiPathReal, {
            Action: 'BatchCalculateProduct',
            Service: 'kcm',
            Version
        }),
        method: 'post'
    },
    //吊销证书  
    RevokeCertificate: {
        url: apiUrl(apiPath, {
            Action: 'RevokeCertificate',
            Service, Version
        }),
        method: 'post'
    },
    //重新签发证书  
    ReIssueCertificate: {
        url: apiUrl(apiPath, {
            Action: 'ReIssueCertificate',
            Service, Version
        }),
        method: 'post'
    },
    //证书延期
    ExtendCertificate: {
        url: apiUrl(apiPath, {
            Action: 'ExtendCertificate',
            Service, Version
        }),
        method: 'post'
    },
    //新价格体系
    QueryPriceSystemNew: apiUrl(apiPath, {
        Action: 'QueryPriceSystemNew',
        Version: '2016-06-07',
        Region: defaultRegion,
        Service
    }),
    //删除证书
    DeleteSSLCertificate: {
        url: apiUrl(apiPath, {
            Action: 'DeleteSSLCertificate',
            Service, Version
        }),
        method: 'post'
    },
    GetQuotainfoByQuotaName: apiUrl(apiPath, {
        Action: 'GetQuotainfoByQuotaName',
        Version,
        Region: defaultRegion,
        Service: quotaService
    }),
};
